import React, { ReactNode, useEffect, useState } from 'react'
import Header from '../../components/Header/Header'
import MenuDrawer from '../../components/MenuDrawer/MenuDrawer'
import Nav from '../../components/Nav/Nav'
import styles from './MainLayout.module.scss'
import { useLocation } from 'react-router-dom'
import { useI18n } from '../../i18n/I18nProvider'
import { getDocumentTitle } from '../../i18n/appText'

interface MainLayoutProps {
  children: ReactNode
}

const MainLayout = ({ children }: MainLayoutProps) => {
  const { t } = useI18n()
  const [isWidthScreen] = useState<boolean>(
    window.innerWidth > 1024 ? true : false,
  )
  const [isActiveMenu, setIsActiveMenu] = useState<boolean>(false)

  const location = useLocation()

  useEffect(() => {
    if (location) {
      document.title = getDocumentTitle(location.pathname, t, location.search)
    }
  }, [location, t])

  const onOpenCloseMenu = (value: boolean) => {
    setIsActiveMenu(value)
  }

  return (
    <div className={styles.root}>
      {isWidthScreen ? (
        <>
          <header className={styles.topBar}>
            <Header />
          </header>
          <div className={styles.bottom}>
            <nav>
              <Nav />
            </nav>
            <main className={styles.main}>{children}</main>
          </div>
        </>
      ) : (
        <>
          <header className={styles.topBar}>
            <Header
              isActiveMenu={isActiveMenu}
              onClickMenuIcon={onOpenCloseMenu}
            />
          </header>
          <div className={styles.bottom}>
            <main className={styles.main}>{children}</main>
            <MenuDrawer
              isActiveMenu={isActiveMenu}
              onClose={() => onOpenCloseMenu(false)}
            />
          </div>
        </>
      )}
    </div>
  )
}

export default MainLayout
